module.exports = __webpack_public_path__ + "img/onetu.6965f08e.png";